class Screen
{
    public width: number;
    public height: number;

    /**
     * Constructor
     */
    constructor()
    {
        this.width = 0;
        this.height = 0;
    }

    /**
     * Sets the size of the screen
     * @param width
     * @param height
     */
    public setSize(width: number, height: number)
    {
        this.width = width;
        this.height = height;
    }
}

export default Screen;